import { ReactElement } from 'react'
import DOMPurify from 'dompurify'
import 'react-quill-new/dist/quill.snow.css'
import 'react-quill-new/dist/quill.core.css'

// Quill content never needs these literal-text tags; forbidding them avoids
// the mutation-XSS smuggling vectors they enable when reparsed as HTML.
const FORBID_TAGS = ['style', 'xmp', 'noembed', 'noframes', 'noscript']

// decodeURI throws on malformed percent-encoding; fall back to the raw value
// rather than crashing the render.
let safeDecodeURI = (value: string): string => {
  try {
    return decodeURI(value)
  } catch {
    return value
  }
}

/**
 * @param htmlVal value you want to dangerously set innerhtml
 * @param isEncoded bool if you have encoded it or not via encodeURI
 * Sanitizes free text from a WYSIWYG or other editor before setting it on the dom
 */

let DangerousHtml = ({
  htmlVal,
  isEncoded = false,
}: {
  htmlVal: string
  isEncoded?: boolean
}): ReactElement => (
  <div id="#quill" className="ql-editor">
    {htmlVal && (
      <div
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(
            isEncoded ? safeDecodeURI(htmlVal) : htmlVal,
            { FORBID_TAGS },
          ),
        }}
      />
    )}
  </div>
)

export default DangerousHtml
